import faker from 'faker';
export const amount = 100;

export default () => ({
    name: faker.name.firstName(),
    contactPerson: faker.name.firstName(),
    createdAt: faker.date.past(),
    apiKeys: [],
});